import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { isSuperAdmin, convertLegacyRole } from "../../constants/roles";

const SuperAdminRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  
  const userRole = convertLegacyRole(user?.role);
  const isSuperAdminUser = isSuperAdmin(userRole);
  
  return isSuperAdminUser ? children : <Navigate to="/portal/dashboard" replace />;
};

export default SuperAdminRoute;


